"use client";

import { EnsIcon } from "@namehash/namehash-ui";
import { Activity, PlugZap, RadioTower, Telescope } from "lucide-react";
import type * as React from "react";

import { NavMain } from "@/components/nav-main";
import { Sidebar, SidebarContent, SidebarHeader, SidebarRail } from "@/components/ui/sidebar";

import { ConnectionsLibrarySelector } from "./connections/connections-library-selector";

const navItems = [
  {
    title: "Connection",
    url: "/connection",
    icon: PlugZap,
  },
  {
    title: "Status",
    url: "/status",
    icon: Activity,
  },
  // {
  //   title: "ENS Explorer",
  //   url: "#",
  //   icon: Telescope,
  //   isActive: true,
  //   items: [
  //     { title: "Names", url: "/name" },
  //     { title: "Registrar Actions", url: "/registrar-actions" },
  //   ],
  // },
  {
    title: "ENS Protocol Inspector",
    url: "#",
    icon: EnsIcon,
    isActive: true,
    items: [
      { title: "Record Resolution", url: "/inspect/records" },
      { title: "Primary Name Resolution", url: "/inspect/primary-name" },
      { title: "Primary Names Resolution", url: "/inspect/primary-names" },
    ],
  },
  {
    title: "APIs",
    url: "#",
    icon: RadioTower,
    isActive: true,
    items: [
      {
        title: "ENS Omnigraph",
        url: "/api/omnigraph",
        badge: "ENSv2 + v1" as const,
      },
      {
        title: "ENS Subgraph",
        url: "/api/subgraph",
        badge: "deprecated" as const,
      },
      {
        title: "REST APIs",
        url: "/api/rest",
      },
    ],
  },
];

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <ConnectionsLibrarySelector />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navItems} />
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
